/**
 * Thin re-export over the shared `apiRequest` helper, with an opt-in
 * fixture-client switch so the data-tables UI is developable before the
 * Workstream-H API merges. Mirrors `knowledge/api/client.ts`.
 */

import { apiRequest as realApiRequest, AgentsApiError } from "../../agents/api/client";

import { fixtureApiRequest } from "./__fixtures__/fixture-client";
import { TABLES_FIXTURES_ENABLED } from "./__fixtures__/fixture-flag";

export const apiRequest = TABLES_FIXTURES_ENABLED ? fixtureApiRequest : realApiRequest;

export { AgentsApiError as TablesApiError };
